


const tacRed = (state = {isTacChecked: false}, action) => {
	switch ( action.type ) {
		case 'TOGGLE_TAC_CHECKBOX':
            return Object.assign({}, state, {
                isTacChecked: action.bool
            });
		default:
			return state
	}
};

export default tacRed


/** WEBPACK FOOTER **
 ** ./src/reducers/tacRed.js
 **/